/**
 * ч.767: призначення платежу податку за шаблоном з картки організації —
 * ДЗЕРКАЛО backend `services/tax_purpose.py:render_tax_purpose`.
 * Змінні: {edrpou} {tax} {tax_name} {period} {mm} {yyyy} {payout} {org} {doc_number} {doc_date}.
 */
// ч.1280: чинний формат (ISO 20022): «101 <текст>» — без «*;» і без коду платника.
export const DEFAULT_TAX_PURPOSE_TEMPLATE = '101 {tax} за {period}';
export const TAX_PURPOSE_VARS_HINT =
  'Змінні: {tax} — текст податку за видом виплати; '
  + '{tax_name} — ПДФО / Військовий збір / ЄСВ; {period} — «серпень 2026 р.»; {mm} {yyyy}; '
  + '{payout} — вид виплати (заробітна плата, аванс, відпускні…); {org} — назва організації; '
  + '{edrpou} — код організації (ЄДРПОУ, у ФОП — РНОКПП). '
  + 'Порожньо = стандарт «101 {tax} за {period}» (код виду сплати 101 і текст; '
  + 'код платника — окремий реквізит платіжки, у призначенні не потрібен).';

const MONTHS_UK = ['', 'січень', 'лютий', 'березень', 'квітень', 'травень', 'червень',
  'липень', 'серпень', 'вересень', 'жовтень', 'листопад', 'грудень'];
const TAX_NAME: Record<string, string> = { PDFO: 'ПДФО', WZ: 'Військовий збір', ESV: 'ЄСВ' };
const TAX_TEXT: Record<string, string> = {
  PDFO: 'ПДФО із заробітної плати найманих працівників',
  WZ: 'Військовий збір із заробітної плати найманих працівників',
  ESV: 'ЄСВ із заробітної плати найманих працівників',
};

export function renderTaxPurposeTemplate(template: string | null | undefined, v: {
  tax_type: string; tax_label?: string; edrpou?: string | null; year: number; month: number;
  payout?: string | null; org?: string | null; doc_number?: string | null; doc_date?: string | null;
}): string {
  const tpl = (template ?? '').trim() || DEFAULT_TAX_PURPOSE_TEMPLATE;
  const period = `${MONTHS_UK[v.month] ?? v.month} ${v.year} р.`;
  const values: Record<string, string> = {
    edrpou: (v.edrpou ?? '').trim(),
    tax: TAX_TEXT[v.tax_type] ?? v.tax_label ?? v.tax_type,
    tax_name: TAX_NAME[v.tax_type] ?? v.tax_label ?? v.tax_type,
    period, mm: String(v.month).padStart(2, '0'), yyyy: String(v.year),
    payout: v.payout ?? 'заробітна плата', org: v.org ?? '',
    doc_number: v.doc_number ?? '', doc_date: v.doc_date ?? '',
  };
  let out = tpl;
  for (const [k, val] of Object.entries(values)) out = out.split(`{${k}}`).join(val);
  return out;
}
